module.exports = __webpack_public_path__ + "img/icon-phone.fff8a48f.svg";